import { render, staticRenderFns } from "./DeleteUserModal.vue?vue&type=template&id=2ef07c12&scoped=true"
import script from "./DeleteUserModal.vue?vue&type=script&lang=js"
export * from "./DeleteUserModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteUserModal.vue?vue&type=style&index=0&id=2ef07c12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef07c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef07c12')) {
      api.createRecord('2ef07c12', component.options)
    } else {
      api.reload('2ef07c12', component.options)
    }
    module.hot.accept("./DeleteUserModal.vue?vue&type=template&id=2ef07c12&scoped=true", function () {
      api.rerender('2ef07c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/DeleteUserModal.vue"
export default component.exports